package one.healthium.login.ui.login

import one.healthium.domain.user.models.SignInOptions

data class SignInUiOptions(
    val username: String = "",
    val password: String = ""
) {
    val options = if (username.isNotBlank() && password.isNotBlank()) {
        SignInOptions.Username(username.trim(), password.trim())
    } else {
        null
    }
}
